export default __webpack_public_path__ + "static/media/SickHolidayIcon.e17308c4.svg";